// @ts-check
import {
  app,
  authentication,
} from '@microsoft/teams-js';
import { isTeamsApp } from '@/utils/device';
import { isJPDomain } from '@/utils/utils';
import { isTeamsRuntimeAsync } from '@/modules/msTeams/sdk';
import { getTeamsDataFromUrl } from '@/modules/msTeams/utils/utils';
import { teamsServerBaseUrl } from '@/modules/msTeams/apis/foxit';

export default class MSForTeamsAppApi {
  constructor() {
    this._init();
  }
  async _init() {
    if (!(await isTeamsRuntimeAsync)) return;
    const context = await app.getContext();
    this.email = context.user && context.user.userPrincipalName;
    this.locale = context.app.locale;
  }
  msTeamsAuthenticationAuthenticate({ url, width, height, successCallback = () => { }, failureCallback = () => { } }) {
    authentication.authenticate({
      url,
      width,
      height,
    }).then(successCallback).catch(failureCallback);
  }
  auth({ url, width = 800, height = 630 }) {
    return authentication.authenticate({
      url,
      width,
      height,
    });
  }
  signInAuth(url) {
    return this.auth({ url }).then(function (result) {
      if (typeof result === 'string') return JSON.parse(result);
      return result;
    }).catch(function (reason) {
      console.log("work fail", reason);
      return Promise.reject();
    })
  }
  signInSignUpQuery() {
    let { email, locale } = this;
    // fix sign in EU instance
    if (!email) {
      ({ email } = getTeamsDataFromUrl());
      locale = '';
    }

    if (isJPDomain()) {
      locale = 'ja_JP'
    }

    return `teamsEmail=${email}&fromOnline=1&locale=${locale}&origin=${window.location.origin}`;
  }
  getTeamsSignInUrl() {
    return `${teamsServerBaseUrl}/foxit-sign-in?${this.signInSignUpQuery()}`;
  }
  getTeamsSignUpUrl() {
    return `${teamsServerBaseUrl}/foxit-sign-in/sign-up?${this.signInSignUpQuery()}`;
  }
}

export function useWindow(cur) {
  // Use editor by Teams website.
  if (window.parent !== window) {
    cur = false;
  }
  // Use editor within Teams App(Desktop, Android, etc.).
  if (isTeamsApp) {
    cur = true;
  }
  return cur;
}

export function signOutIfTeamsWebsiteUrl() {
  // Use editor by Teams website.
  if (window.parent !== window) {
    return encodeURIComponent(location.origin + "/sites/sign-out-callback.html");
  }
  return '';
}
